module.exports = __webpack_public_path__ + "static/img/A160.99045e39.jpg";